import {
  decodeCheckoutData,
  decodeStatusData,
  extractIntegrationData,
  extractRestrictedPageId,
  parseAppSectionParams,
} from '@wix/pricing-plans-router-utils';
import { ControllerParams } from '@wix/yoshi-flow-editor';
import { SubPage } from '../../../types/common';
import { isDayful } from '../../../utils/is-dayful';
import { getSectionId, getSubPagePath } from '../../../utils/navigation';

export class Navigation {
  constructor(
    protected wixCodeApi: ControllerParams['controllerConfig']['wixCodeApi'],
    protected flowAPI: ControllerParams['flowAPI'],
    protected appDefinitionId: string,
    protected readonly hasMultiplePages: boolean,
  ) {}

  get isMultiPageApp() {
    return this.hasMultiplePages;
  }

  async setCurrentPath(subPage: SubPage) {
    const { appDefinitionId, isMultiPageApp } = this;
    const sectionId = getSectionId(subPage.name, { isMultiPageApp });
    const path = getSubPagePath(subPage, { isMultiPageApp });
    const { relativeUrl } = await this.wixCodeApi.site.getSectionUrl({ appDefinitionId, sectionId });
    this.wixCodeApi.location.to!((relativeUrl ?? '') + path, { disableScrollToTop: true });
  }

  async getCurrentSubPage(): Promise<SubPage> {
    const { location } = this.wixCodeApi;
    const { path } = location;
    if (path[1] === 'payment') {
      return { name: 'checkout', checkoutData: decodeCheckoutData(path[2]) };
    } else if (path[1] === 'status') {
      return {
        name: 'status',
        statusData: decodeStatusData(path[2]),
      };
    } else {
      const params = parseAppSectionParams(location.query?.appSectionParams);
      const pageId = extractRestrictedPageId(params);
      const integrationData = extractIntegrationData(params);
      if (pageId) {
        return { name: 'restricted', pageId, integrationData };
      }
      return {
        name: 'list',
        integrationData: (await isDayful(this.flowAPI, this.wixCodeApi))
          ? { ...integrationData, navigateTo: location.baseUrl + '/_api/dayful/sch/route' }
          : integrationData,
      };
    }
  }
}
